import 'components/chrome/Topnav.scss';
import React from 'react';
import axle_logo_med_white from 'img/axle_logo_med_white.png';
import { Button } from 'primereact/button';
import { Link, NavLink } from 'react-router-dom';
import { Sidebar } from 'primereact/sidebar';
import { withRouter } from 'react-router';
import Server from 'data/Server';
import Sitemap from 'components/app/Sitemap';


const SpecialLinks = {
  LOGIN: {
    label: 'Login',
    path: '/login',
  },
  LOGOUT: {
    label: 'Log Out',
    path: '/goodbye',
  },
};


class Topnav extends React.Component {
  constructor() {
    super();
    this.state = { sidebarVisible: false };
    this.server = new Server.Factory().create();
    this.sitemap = new Sitemap.Factory().create();
  }

  mkLink(label, path, className) {
    if (!path) {
      path = '/' + label.toLowerCase();
    }
    return (
      <NavLink
          key={label}
          to={path}
          className={className + ' nav'}
          activeClassName='selected'
          onClick={e => e /*this.setState({sidebarVisible: false})*/}>
        {label}
      </NavLink>
    );
  }

  filter(links) {
    let filtered = links;

    // Show 'showIf=fn()' links only if showIf evaluates true.
    filtered = filtered.filter(i => !i.showIf || i.showIf());

    // Add login/logout options.
    filtered.push(
        this.server.user_email() ? SpecialLinks.LOGOUT : SpecialLinks.LOGIN);

    return filtered;
  }

  render() {
    let links = this.filter(this.props.links || []);
    return (
      <div className='Topnav sticky'>
        <div className='left'>
          <Link to='/'>
            <img src={axle_logo_med_white} className='logo' alt='Axle logo' />
          </Link>
          <div className='title'>
            {this.props.children}
          </div>
        </div>
        <div className='right'>
          <div className='desktop'>
            {links.map(i => this.mkLink(i.label, i.path, i.className))}
          </div>
          <div className='mobile'>
            <Sidebar
                position='right'
                className='sidebar'
                visible={this.state.sidebarVisible}
                onHide={(e) => this.setState({sidebarVisible: false})}>
              {links.map(i => this.mkLink(i.label, i.path, i.className))}
            </Sidebar>
            {links.length ?
                <Button
                    className='sidebarButton'
                    icon='pi pi-bars'
                    onClick={(e) => this.setState({sidebarVisible: true})}/>
                : ''}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Topnav);
